import { useEffect } from "react";

// Le manifeste rend l'application installable : le navigateur propose alors son
// installation (icône de la barre d'adresse, bannière). Il n'est déclaré que dans la
// Nouvelle interface, pour que l'interface Classique ne propose jamais l'installation,
// et dans l'application installée, qui en a besoin pour se mettre à jour.
export const MANIFEST_LINK_ID = "akongo-pwa-manifest";

const manifestHref = () => `${process.env.PUBLIC_URL || ""}/manifest.json`;

// Claimants actifs : la coque V2 peut être montée plusieurs fois (transitions de route).
let claims = 0;
let permanent = false;

const ensureLink = (doc) => {
  if (!doc?.head || doc.getElementById(MANIFEST_LINK_ID)) return;
  const link = doc.createElement("link");
  link.id = MANIFEST_LINK_ID;
  link.rel = "manifest";
  link.href = manifestHref();
  doc.head.appendChild(link);
};

const removeLink = (doc) => {
  doc?.getElementById(MANIFEST_LINK_ID)?.remove();
};

/** Déclare le manifeste pour toute la session (application installée). */
export function attachManifestPermanently(doc = typeof document === "undefined" ? null : document) {
  permanent = true;
  ensureLink(doc);
}

/** Déclare le manifeste tant qu'une vue V2 le demande. Rend la fonction qui le retire. */
export function claimManifest(doc = typeof document === "undefined" ? null : document) {
  claims += 1;
  ensureLink(doc);
  let released = false;
  return () => {
    if (released) return;
    released = true;
    claims = Math.max(0, claims - 1);
    if (claims === 0 && !permanent) removeLink(doc);
  };
}

export function useManifestLink(enabled) {
  useEffect(() => (enabled ? claimManifest() : undefined), [enabled]);
}

// Tests uniquement.
export function resetManifestLinkForTests(doc = typeof document === "undefined" ? null : document) {
  claims = 0;
  permanent = false;
  removeLink(doc);
}
